import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Heading5, Caption } from '../../../components/Typography';
import { ReactComponent as CopyIcon } from '../../../assets/svg/copy-icon.svg';

import './index.scss';

const immunotherapyIframeSrc =
  process.env.REACT_APP_ALLERGY_CONSULTATION_IFRAME;

const ImmunotherapyIframe = ({ data }) => {
  const text = data?.info?.text;
  const testCode = data?.info?.testCode;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);

  const handleLoading = () => setLoading(false);
  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  const handleCopyCode = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }

    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  return (
    <div className='immunotherapy-iframe'>
      <Heading5 className='immunotherapy-iframe__title'>{text}</Heading5>

      {testCode && (
        <div className='immunotherapy-iframe__code-block'>
          <button
            className='immunotherapy-iframe__copy-button'
            onClick={() => handleCopyCode(testCode)}
          >
            <Heading5 className='immunotherapy-iframe__code'>
              {testCode} <CopyIcon />
            </Heading5>
          </button>
          {copySuccess && (
            <div className='immunotherapy-iframe__copy-success'>
              <Caption>
                <FormattedMessage
                  id='my-health.copied'
                  defaultMessage='Copied'
                />
              </Caption>
            </div>
          )}
        </div>
      )}

      <div
        className={cx('immunotherapy-iframe__content', {
          'immunotherapy-iframe__content--no-error': !error,
        })}
      >
        {loading && (
          <div className='immunotherapy-iframe__loading-overlay'>
            <div className='immunotherapy-iframe__loader' />
          </div>
        )}
        {error ? (
          <Heading5 className='booking-iframe__error-message'>
            <FormattedMessage
              id='test-result.try-again-later'
              defaultMessage='Something went wrong. Please try again later.'
            />
          </Heading5>
        ) : (
          <iframe
            src={immunotherapyIframeSrc}
            title='Immunotherapy Consultation'
            width='100%'
            height='100%'
            frameBorder={0}
            onLoad={handleLoading}
            onError={handleError}
          />
        )}
      </div>
    </div>
  );
};

ImmunotherapyIframe.propTypes = {
  data: PropTypes.shape({
    info: PropTypes.shape({
      text: PropTypes.string,
      testCode: PropTypes.string,
    }),
  }),
};

export default ImmunotherapyIframe;
